export default {
      id: "zoomIn-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#zoomIn-usage",
      toString: function () {
        return this.url;
      }
    }